import deepmerge from 'deepmerge';
import { light, dark } from './color';
var defaultPalette = light;
export { defaultPalette };
export var createColorPalette = function createColorPalette(paletteOption) {
  var type = paletteOption.type;
  var colorPalette = type === 'dark' ? dark : light;
  var palette = typeof paletteOption === 'function' ? paletteOption(defaultPalette) : paletteOption;
  return deepmerge(colorPalette, palette, {
    clone: false
  });
};